import { apiClient } from './api'
import type { DashboardSummary } from '@/types/dashboard.types'
import type { TriggeredAlert } from '@/types/alert.types'
import type { Device } from '@/types/device.types'

export const dashboardService = {
  getSummary: async (): Promise<DashboardSummary> => {
    const { data } = await apiClient.get('/dashboard/summary')

    // Map API response (snake_case) to frontend types (camelCase)
    const mapAlert = (alert: any): TriggeredAlert => ({
      id: alert.id,
      alertId: alert.alert_id,
      deviceId: alert.device_id,
      deviceName: alert.device_name,
      deviceSerialNumber: alert.device_serial_number || '',
      accountId: alert.account_id,
      accountName: alert.account_name,
      measurementColumn: alert.measurement_column,
      triggeredValue: alert.triggered_value,
      alertMessage: alert.alert_message,
      severityLevel: alert.severity_level?.toLowerCase() || 'warning',
      triggeredAt: alert.triggered_at,
      isDismissed: alert.is_dismissed,
      dismissedAt: alert.dismissed_at,
      dismissedBy: alert.dismissed_by,
      paramLabel: alert.param_label,
      unit: alert.unit
    })

    const mapDevice = (device: any): Device => ({
      id: device.id,
      name: device.name,
      serialNumber: device.serial_number,
      deviceType: device.device_type,
      status: device.status,
      accountId: device.account_id,
      accountName: device.account_name,
      lastSeen: device.last_seen,
      batteryLevel: device.battery_level,
      lat: device.lat,
      long: device.long,
      hardwareVersion: device.hardware_version,
      firmwareVersion: device.firmware_version,
      lastMeasurement: device.latest_measurement,
      orbcommModem: device.orbcomm_modem || false,
      isFavorite: device.is_favorite || false,
      isActive: device.is_active ?? true,
      createdAt: device.created_at,
      updatedAt: device.updated_at
    })

    return {
      totalDevices: data.stats.total_devices,
      devicesOnline24h: data.stats.devices_online_24h,
      activeAlerts: data.stats.active_alerts,
      accountCount: data.stats.accounts,
      recentAlerts: (data.recent_alerts || []).map(mapAlert),
      recentDevices: (data.devices || []).map(mapDevice)
    }
  }
}
